import { useQuery } from '@tanstack/react-query';
import { ScheduleConfigService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useVacationRequestsQuery = (isEnabled: boolean) =>
  useQuery({
    queryKey: queryKeys.schedule.vacationRequests(),
    queryFn: () =>
      ScheduleConfigService.scheduleConfigServiceGetVacationRequests(),
    enabled: isEnabled,
  });
